import { Box, Drawer } from "@mui/material";
import { alpha } from "@mui/material/styles";
import LinksDrawer from "./LinksDrawer";
import LogoutButton from "../buttons/LogoutButton";
import AppLogo from "./AppLogo";
import { SIDEBAR_WIDTH } from "../layout/layoutStyles";

export const DRAWER_WIDTH = SIDEBAR_WIDTH;

const drawerPaperSx = {
  boxSizing: "border-box",
  width: DRAWER_WIDTH,
  bgcolor: "background.paper",
  border: 0,
  borderLeft: 1,
  borderColor: "divider",
  boxShadow: "none",
  display: "flex",
  flexDirection: "column",
};

type Props = {
  mobileOpen: boolean;
  onMobileClose: () => void;
};

const SideDrawer = ({ mobileOpen, onMobileClose }: Props) => {
  const drawerContent = (
    <>
      <AppLogo />
      <Box sx={{ flex: 1, overflow: "auto", py: 1 }}>
        <LinksDrawer onNavigate={onMobileClose} />
      </Box>
      <Box
        sx={{
          px: 1.5,
          py: 1.5,
          borderTop: 1,
          borderColor: "divider",
          bgcolor: (theme) => alpha(theme.palette.grey[50], 0.8),
        }}
      >
        <LogoutButton />
      </Box>
    </>
  );

  return (
    <Box
      component="nav"
      sx={{
        width: { md: DRAWER_WIDTH },
        flexShrink: { md: 0 },
      }}
      aria-label="navigation"
    >
      <Drawer
        variant="temporary"
        SlideProps={{ direction: "left" }}
        open={mobileOpen}
        onClose={onMobileClose}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": drawerPaperSx,
        }}
      >
        {drawerContent}
      </Drawer>

      <Drawer
        variant="permanent"
        SlideProps={{ direction: "left" }}
        sx={{
          display: { xs: "none", md: "block" },
          "& .MuiDrawer-paper": drawerPaperSx,
        }}
        open
      >
        {drawerContent}
      </Drawer>
    </Box>
  );
};

export default SideDrawer;
